import { useState,useEffect,useContext } from 'react'
import { useNavigate } from 'react-router-dom'
import { Alert, AppBar, Box, Card, CardContent, Grid, Tab, Table, TableBody, TableCell, TableRow, Tabs, TextField } from '@mui/material'
import { post } from '../../utils/axios'
import { toast } from 'react-toastify'
import Button from '../../components/Button'
import QrReader from 'modern-react-qr-reader'
import SearchBox from '../../components/SearchBox'
import { Context } from '../../context/Context'
import axios from 'axios'

const Payment = () => {
    const context = useContext(Context)
    const navigate = useNavigate()

    const [isLoading,setIsLoading] = useState(false)
    const [orderId,setOrderId] = useState('')
    const [hasFindOrder,setHasFindOrder] = useState(false)
    const [order,setOrder] = useState([])
    const [totalPrice,setTotalPrice] = useState(0)
    const [isPaid,setIsPaid] = useState(false)
    const [businessTitle,setBusinessTitle] = useState('')
    const [tab,setTab] = useState(0)
    const [parentTab,setParentTab] = useState(0)
    const [result,setResult] = useState(null)
    const [terminal,setTerminal] = useState('')
    const [searchText,setSearchText] = useState('')
    const [businesses,setBusinesses] = useState([])
    const [filteredBusinesses,setFilteredBusinesses] = useState([])

    const isPhone = navigator.share

    useEffect(() => {
        post('Business/GetAllBusinessNames').then(({ data }) => {
            if(data.isSuccess){
                setBusinesses(data.data)
                setFilteredBusinesses(data.data)
            }
        }).finally(() => {
            setIsLoading(false)
        })
    },[])

    useEffect(() => {
        if(orderId && orderId.length){
            if(orderId.includes('۰'))
                setOrderId(orderId.replace(/۰/g,'0'))
            if(orderId.includes('۱'))
                setOrderId(orderId.replace(/۱/g,'1'))
            if(orderId.includes('۲'))
                setOrderId(orderId.replace(/۲/g,'2'))
            if(orderId.includes('۳'))
                setOrderId(orderId.replace(/۳/g,'3'))
            if(orderId.includes('۴'))
                setOrderId(orderId.replace(/۴/g,'4'))
            if(orderId.includes('۵'))
                setOrderId(orderId.replace(/۵/g,'5'))
            if(orderId.includes('۶'))
                setOrderId(orderId.replace(/۶/g,'6'))
            if(orderId.includes('۷'))
                setOrderId(orderId.replace(/۷/g,'7'))
            if(orderId.includes('۸'))
                setOrderId(orderId.replace(/۸/g,'8'))
            if(orderId.includes('۹'))
                setOrderId(orderId.replace(/۹/g,'9'))
        }
    },[orderId])

    useEffect(() => {
        if(terminal && terminal.length){
            if(terminal.includes('۰'))
                setTerminal(terminal.replace(/۰/g,'0'))
            if(terminal.includes('۱'))
                setTerminal(terminal.replace(/۱/g,'1'))
            if(terminal.includes('۲'))
                setTerminal(terminal.replace(/۲/g,'2'))
            if(terminal.includes('۳'))
                setTerminal(terminal.replace(/۳/g,'3'))
            if(terminal.includes('۴'))
                setTerminal(terminal.replace(/۴/g,'4'))
            if(terminal.includes('۵'))
                setTerminal(terminal.replace(/۵/g,'5'))
            if(terminal.includes('۶'))
                setTerminal(terminal.replace(/۶/g,'6'))
            if(terminal.includes('۷'))
                setTerminal(terminal.replace(/۷/g,'7'))
            if(terminal.includes('۸'))
                setTerminal(terminal.replace(/۸/g,'8'))
            if(terminal.includes('۹'))
                setTerminal(terminal.replace(/۹/g,'9'))
        }
    },[terminal])

    useEffect(() => {
        const filteredData = [...businesses]
        setFilteredBusinesses(filteredData.filter(d => d.title?.includes(searchText)))
    },[searchText])

    useEffect(() => {
        if(result != null){
            axios.post('https://petromah.sabinarya.com/service/api/Business/validatePaymentType',{terminalNo: result,channel: 2}).then(({data}) => {
                if(data.status && data.result)
                    window.open(`${result}&callback=${context.profile.roleId != 103 ? process.env.REACT_APP_TRANSACTION_CALLBACK_URL : process.env.REACT_APP_TRANSACTION_CALLBACK_CHILD_URL}&mobileNumber=${context.profile.mobile}`,'_blank')
                else
                    toast.error('امکان پرداخت برای این کسب و کار از طریق اپلیکیشن وجود ندارد')
            })
        }
    },[result])

    const paymentByTerminal = () => {
        const postedData = {
            terminalNo: terminal,
            channel: 4
        }
        console.log(postedData);
        axios.post('https://petromah.sabinarya.com/service/api/Business/validatePaymentType',postedData).then(({data}) => {
            if(data.status && data.result)
                window.open(`https://ipg.sabinarya.com/payment/ipg/qr/app/?terminalNumber=${terminal}&callback=${context.profile.roleId != 103 ? process.env.REACT_APP_TRANSACTION_CALLBACK_URL : process.env.REACT_APP_TRANSACTION_CALLBACK_CHILD_URL}&mobileNumber=${context.profile.mobile}`,'_blank')
            else
                toast.error('امکان پرداخت برای این کسب و کار از طریق اپلیکیشن وجود ندارد')
        })
    }

    const findOrder = () => {
        setHasFindOrder(false)
        setIsLoading(true)
        const postedData = {
            serviceConsumerId: orderId
        }
        post('Order/GetOrder',postedData).then(({data}) => {
            if(data.isSuccess){
                if(data.data.businessId){
                    axios.post('https://petromah.sabinarya.com/service/api/Business/validatePaymentType',{businessId: data.data.businessId,channel: 5}).then(res => {
                        if(res.data.status && res.data.result){
                            let calcTotalPrice = 0
                            let generatedOrder = []
                            let itemIndex = 0
                            data.data.subServiceId.map(item => {
                                calcTotalPrice += item.price
                                itemIndex = generatedOrder.findIndex(i => i.id === item.id)
                                if(itemIndex != -1){
                                    generatedOrder[itemIndex].count = generatedOrder[itemIndex].count + 1
                                }else{
                                    generatedOrder.push({...item,count: 1})
                                }
                            })
                            if(data.data.paymentResponseCode == '00')
                                setIsPaid(true)
                            post('Business/GetBusinessById',{id: data.data.businessId}).then(response => {
                                if(response.data.isSuccess)
                                    setBusinessTitle(response.data.data.title)
                            }).finally(() => {
                                setHasFindOrder(true)
                                setIsLoading(false)
                            })
                            setOrder(generatedOrder)
                            setTotalPrice(calcTotalPrice)
                        }
                    })
                }
            }else{
                setIsLoading(false)
                toast.error(data.message)
            }
        }).catch(() => {
            setIsLoading(false)
        })
    }

    return (
        <Grid item px={0.3}>
            <h3 className="others-page-title">پرداخت سریع</h3>
            <div className="safe-area">
                <div id="custom-payment-tab">
                    <Box sx={{ width: '100%',mb: 2 }}>
                        <AppBar position="static" variant="outlined">
                            <Box sx={{ borderBottom: 1,orderColor: 'divider',borderBottomColor: 'rgba(0,0,0,0.2)' }}>
                                <Tabs value={parentTab} onChange={(e,newValue) => setParentTab(newValue)} centered indicatorColor="secondary" textColor="inherit">
                                    <Tab label="پرداخت بر اساس شناسه" />
                                    <Tab label="پرداخت بر اساس نام" />
                                </Tabs>
                            </Box>
                        </AppBar>
                    </Box>
                </div>
                {parentTab == 0 ? <>
                    <Box sx={{ borderBottom: 1,orderColor: 'divider',borderBottomColor: 'rgba(0,0,0,0.2)',mb: 2 }}>
                    <Tabs value={tab} onChange={(e,newValue) => setTab(newValue)} centered>
                        <Tab label="جستجو فاکتور" />
                        <Tab label="اسکن QRCode" />
                        <Tab label="شماره پایانه" />
                    </Tabs>
                </Box>
                {tab == 0 ? <>
                    <Card sx={{ width: '100%',mb: 3 }}>
                        <CardContent style={{ paddingBottom: 16 }}>
                            <TextField label="شناسه فاکتور" type="tel" inputProps={{maxLength: 8}} className="ltr-input" variant="standard" fullWidth sx={{mb: 2.5,mt: 1}} onChange={e => setOrderId(e.target.value)} value={orderId} />
                            <Button type="submit" isLoading={isLoading} fullWidth={true} sx={{py: 1.5}} className="custom-btn-primary" variant="contained" disabled={!orderId} onClick={findOrder}>دریافت اطلاعات فاکتور</Button>
                        </CardContent>
                    </Card>
                    {hasFindOrder ? (order.length ? <Card sx={{ width: '100%',mb: 5 }}>
                        <CardContent style={{ paddingBottom: 16 }}>
                            <h4>جزئیات سفارش{businessTitle ? ` از ${businessTitle}` : ''}</h4>
                            <Table>
                                <TableBody>
                                    {order.map((item,index) => <TableRow key={index} sx={{'&:last-child td,&:last-child th': {border: 0,marginBottom: 0,paddingBottom: 0.5}}}>
                                        <TableCell align="right">{item.title} <i className="fal fa-xmark"></i> {item.count}</TableCell>
                                        <TableCell align="right">{new Intl.NumberFormat('en-IR', {maximumSignificantDigits: 20}).format(item.price * item.count)} ریال</TableCell>
                                    </TableRow>)}
                                    <TableRow sx={{'&:last-child td,&:last-child th': {border: 0,marginBottom: 0,paddingBottom: 3}}}>
                                        <TableCell align="right"><b>مجموع</b></TableCell>
                                        <TableCell align="right">{new Intl.NumberFormat('en-IR', {maximumSignificantDigits: 20}).format(totalPrice)} ریال</TableCell>
                                    </TableRow>
                                </TableBody>
                            </Table>
                            {isPaid ? <Alert severity="info" className="custom-alert" sx={{my: 0}}>این فاکتور قبلاً پرداخت شده است</Alert> : <Button type="submit" isLoading={isLoading} fullWidth={true} sx={{mt: 3,py: 1.5}} color="success" variant="contained" disabled={!orderId || !findOrder} onClick={() => navigate(`/app/basket/confirm/${orderId}`)}>پرداخت فاکتور</Button>}
                        </CardContent>
                    </Card> : <Alert severity="info" className="custom-alert" sx={{my: 3}}>شماره فاکتور در سیستم یافت نشد</Alert>) : ''}
                </> : ''}
                {tab == 1 ? (isPhone ? <QrReader delay={300} facingMode="environment" onScan={result => setResult(result)} onError={error => toast.error('خطایی در پردازش تصویر رخ داده است')} /> : <Alert severity="info" className="custom-alert" sx={{my: 3}}>این عملیات فقط در موبایل امکان پذیر است</Alert>) : ''}
                {tab == 2 ? <Card sx={{ width: '100%',mb: 3 }}>
                    <CardContent style={{ paddingBottom: 16 }}>
                        <TextField label="شماره پایانه" type="tel" className="ltr-input" variant="standard" inputProps={{maxLength: 11}} fullWidth sx={{mb: 2.5,mt: 1}} onChange={e => setTerminal(e.target.value)} value={terminal} />
                        <Button type="submit" fullWidth={true} sx={{py: 1.5}} className="custom-btn-primary" variant="contained" disabled={!terminal} onClick={paymentByTerminal}>پرداخت</Button>
                    </CardContent>
                </Card> : ''}
                </> : ''}
                {parentTab == 1 ? <>
                    <SearchBox searchText={searchText} setSearchText={setSearchText} />
                    {filteredBusinesses.length ? filteredBusinesses.map(business => <Card key={`${business.title}-${business.terminalNo}`} sx={{ width: '99%',mb: 2,mx: '0.5%'}}>
                        <CardContent sx={{position: 'relative'}}>
                            <span className="fast-pay-business-title">{business.title}</span>
                            <Button variant="contained" className="fast-pay-business-btn" color="primary" onClick={() => window.open(`https://ipg.sabinarya.com/payment/ipg/qr/app/?terminalNumber=${business.terminalNo}&callback=${context.profile.roleId != 103 ? process.env.REACT_APP_TRANSACTION_CALLBACK_URL : process.env.REACT_APP_TRANSACTION_CALLBACK_CHILD_URL}&mobileNumber=${context.profile.mobile}`,'_blank')}>پرداخت</Button>
                        </CardContent>
                    </Card>) : <Alert variant="standard" color="info">کسب و کاری جهت نمایش یافت نشد</Alert>}
                </> : ''}
            </div>
        </Grid>
    )
}

export default Payment